import isArray from "lodash/isArray";

const validator = {
  getMessage() {
    return "The files uploaded are not in the supported file formats.";
    // return field + " file(s) extension must be " + extensions;
  },
  validate(value, extensions) {
    const regex = new RegExp(`.(${extensions.join("|")})$`, "i");

    // multiple
    if (isArray(value)) {
      return value.every(file => regex.test(file.name));
    } else {
      return regex.test(value.name);
    }
  }
};

export default validator;
